var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popin",on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.cancel.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }